export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/8fa34e8a9656356acdf525352d1d0e87.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <div className="mb-6">
            <span className="text-purple-400 text-xs font-semibold tracking-widest uppercase">
              SECURE VPN SERVICE
            </span>
          </div>
          
          <h1 className="text-6xl font-bold text-white mb-8 leading-tight">
            Your Privacy Shield in the Digital World
          </h1>
          
          <p className="text-xl text-white/80 mb-12 leading-relaxed max-w-xl">
            Enterprise-grade encryption protecting your online activities across all devices
          </p>
          
          <div className="flex items-center gap-6">
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-8 py-4 rounded-full text-base font-medium hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Start Free Trial
              <i className="ri-arrow-right-line"></i>
            </button>
            
            <button 
              onClick={() => scrollToSection('vpn-service')}
              className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white hover:text-purple-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
